import {
  GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_FAILURE,
  GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_LOADING,
  GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_SUCCESS,
} from "../../actions/actionTypes";

const INITIAL_STATE = {
  companyLoans: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
        messageDetail: "",
      },
    },
  },
};

const financeReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_LOADING:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: true,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_SUCCESS:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: false,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_SAFEARTH_DASHBOARD_FINANCE_DETAILS_FAILURE:
      return {
        ...state,
        companyLoans: {
          ...state.companyLoans,
          get: {
            ...state.companyLoans.get,
            loading: false,
            reset: false,
            success: {
              ...state.companyLoans.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
              messageDetail: action.payload.messageDetail || "",
            },
          },
        },
      };
  }
  return state;
};

export default financeReducers;
